export default function ($) {
  $(document).ready(function(){
    var featuresList = $('.js-feature-list');

    var highlightOutFeature = function( feature ) {
      feature.removeClass('opacity-100');
      feature.addClass('opacity-40');
    };

    var highlightInFeature = function( feature ) {
      feature.removeClass('opacity-40');
      feature.addClass('opacity-100');
    };

    featuresList.each(function() {
      var first = $(this).find('.js-feature').first(),
          feature = $(this).children('.js-feature');

      //First we set the first feature highlighted
      highlightInFeature(first);

      feature.mouseenter( function(e) {
        var feature_number = $(this).data('feature'),
          feature_phone = $(this).parents('.js-feature-block').find('#js-feature-media-' + feature_number),
          other_features = $(this).siblings('.js-feature');

        other_features.each(function () {
          var other_feature_number = $(this).data('feature'),
              other_feature_phone = $(this).parents('.js-feature-block').find('#js-feature-media-' + other_feature_number);
          other_feature_phone.addClass('hidden');

        })

        //When the mouse enter a feature div, hightlight out all features but this one and display its phone picture
        highlightOutFeature(feature);
        highlightInFeature($(this));

        feature_phone.removeClass('hidden');
      });
    });

  });

}
